if (!customElements.get('product-quick-popup')) {
  customElements.define(
    'product-quick-popup',
    class ProductQuickPopup extends HTMLElement {
      constructor() {
        super();
        this.closeButton = this.querySelector('.product-quick-popup__close');
        this.content = this.querySelector('.product-quick-popup__body');
        this.productIds = JSON.parse(this.dataset.productIds);
        this.currency = this.dataset.currency;
        this.outsideClickListener = null;
      }

      connectedCallback() {
        // For each product card, open the popup on click
        document.querySelectorAll('.pack-card').forEach(card => {
          card.addEventListener('click', this.openPopup.bind(this));
        });

        this.closeButton.addEventListener('click', this.close.bind(this));
        document.addEventListener('cart:updated', this.close.bind(this));
      }

      openPopup(e) {
        const packCard = e.target.closest('.pack-card');
        if (!packCard) return;

        const productUrl = packCard.dataset.productUrl;
        if (!productUrl) return;

        // Hard-coded PREORDER message (edit as needed)
        const HARD_CODED_MESSAGE = `
          Note: This is a PREORDER. It allows you to get in line for the product so you get it first 
          when it gets back in stock. The whole order will be held until the entire order is in stock 
          to ship together. Items will be paid for at time of checkout and Items will ship once in stock. 
          Email us if you want to pay up and separate the order. <br>• <strong>Shipping:</strong> 4-6 Weeks
        `;

        // Show loading UI (spinner)
        const imageWrapper = packCard.querySelector('.pack-card-image-wrapper');
        if (imageWrapper) {
          imageWrapper.classList.add('loading');
          const spinner = imageWrapper.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }

        // Fetch product page HTML
        fetch(productUrl)
          .then(response => response.text())
          .then(responseText => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            if (!productElement) return;

            // Prevent the product form from updating the URL
            productElement.setAttribute('data-update-url', 'false');

            // Inject product HTML into the popup content
            HTMLUpdateUtility.setInnerHTML(this.content, productElement.outerHTML);

            // Show the popup
            document.body.classList.add('overflow-hidden');
            this.classList.add('open');

            // Attach outside-click listener after popup is open.
            // This listener checks if the click is outside the element with class 'product-quick-popup__content'
            this.outsideClickListener = (event) => {
              const popupContent = this.querySelector('.product-quick-popup__content');
              if (popupContent && !popupContent.contains(event.target)) {
                this.close();
              }
            };
            document.addEventListener('click', this.outsideClickListener);

            // Find the "Add to Cart" button inside the popup
            const addToCartButton = this.content.querySelector('.product-form__submit');
            if (!addToCartButton) return;

            const preOrderContainerPDP = document.getElementById("display-pre-order-message");
            preOrderContainerPDP.style.display = "none";

            // Find (or create) the #display-pre-order-message-2 container
            const preOrderContainer = this.content.querySelector('#display-pre-order-message-2');
            if (preOrderContainer) {
              preOrderContainer.style.display = 'none';
              preOrderContainer.innerHTML = '';
            }

            // Function to check if button text is "Pre-order" and then show/hide the container
            function checkPreOrder() {
              if (addToCartButton.textContent.trim() === 'Pre-order' && preOrderContainer) {
                preOrderContainer.innerHTML = HARD_CODED_MESSAGE;
                preOrderContainer.style.display = 'block';
              } else if (preOrderContainer) {
                preOrderContainer.innerHTML = '';
                preOrderContainer.style.display = 'none';
              }
            }

            // Initial check
            checkPreOrder();

            // Observe button changes (for variant changes, etc.)
            const observer = new MutationObserver(checkPreOrder);
            observer.observe(addToCartButton, { childList: true, subtree: true });

            // Override default Add to Cart form submission
            addToCartButton.addEventListener('click', event => {
              event.preventDefault();

              const form = addToCartButton.closest('form');
              if (!form) return;
              const formData = new FormData(form);

              fetch('/cart/add.js', {
                method: 'POST',
                body: formData
              })
              .then(res => res.json())
              .then(cart => {
                console.log('Product added to cart:', cart);
                setTimeout(() => {
                  this.close();
                  fetch('/cart.js')
                    .then(response => response.json())
                    .then(data => {
                      console.log("Data==>", data);
                      let totalItems = data.items.reduce((sum, item) => sum + item.quantity, 0);
                      if (document.querySelector(".cart-count-bubble > span")) {
                       document.querySelector(".cart-count-bubble > span").innerHTML = totalItems;
                      } else {
                        let newElement = document.createElement("div");
                        newElement.className = "cart-count-bubble";
                        newElement.innerHTML = `<span>${totalItems}</span>`;
                        document.querySelector('.header__icon--cart').appendChild(newElement);
                      }
                    })
                    .catch(err => console.log("Error detected==>", err));
                    document.dispatchEvent(new Event('cart:updated'));
                }, 700);
              })
              .catch(error => {
                console.error('Error adding product to cart:', error);
              });
            });

            // Refresh Preorder app if needed
            if (window.DashPreorders && typeof window.DashPreorders.refresh === 'function') {
              window.DashPreorders.refresh();
              console.log('Preorder app refreshed');
            }
          })
          .finally(() => {
            // Hide loading UI
            if (imageWrapper) {
              imageWrapper.classList.remove('loading');
              const spinner = imageWrapper.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
            }
          });
      }

      close() {
        document.body.classList.remove('overflow-hidden');
        this.classList.remove('open');
        if (this.outsideClickListener) {
          document.removeEventListener('click', this.outsideClickListener);
          this.outsideClickListener = null;
        }
      }
    }
  );
}
